import { clearAllPersistedFilters } from "./persistListFilters";

const getStoredJwt = () => {
    if (typeof window === "undefined") {
        return null;
    }

    const raw = localStorage.getItem("jwt");

    if (!raw) {
        return null;
    }

    try {
        const parsed = JSON.parse(raw);

        if (typeof parsed === "string") {
            return parsed;
        }

        if (parsed && typeof parsed === "object") {
            return parsed.token ?? null;
        }

        return null;
    } catch (error) {
        // Stored value is already the token string.
        return raw;
    }
}

export const isAuthenticated = () => Boolean(getStoredJwt());

export const getJwtToken = () => getStoredJwt();

export const clearAuthSession = () => {
    if (typeof window === "undefined") {
        return;
    }

    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    clearAllPersistedFilters();
};

/** Lab admins and platform support accounts: both carry the admin's powers in the vendor portal. */
export const isVendorAdminUser = (user) => {
    const type = String(user?.user_type_name ?? user?.user_type?.name ?? user?.userType?.name ?? '').toLowerCase();

    return type === 'admin' || type === 'support';
};

export const getStoredUser = () => {
    if (typeof window === "undefined") {
        return null;
    }

    const raw = localStorage.getItem("user");

    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch (error) {
        return raw;
    }
}